import { render, staticRenderFns } from "./scope-of-activity-component.vue?vue&type=template&id=185c0ba5"
import script from "./scope-of-activity-component.ts?vue&type=script&lang=ts&external"
export * from "./scope-of-activity-component.ts?vue&type=script&lang=ts&external"
import style0 from "./scope-of-activity-component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports